/**
 * Formate le username Keycloak comme l'app mobile :
 * numéro national seul (ex. 699123456), sans indicatif pays.
 */
export function resolveKeycloakUsername(phone: string, dialCode = '+237'): string {
  const digits = phone.replace(/\D/g, '');
  const dialDigits = dialCode.replace(/\D/g, '');

  if (dialDigits && digits.startsWith(dialDigits) && digits.length > dialDigits.length) {
    return digits.slice(dialDigits.length);
  }

  return digits;
}
